import { requestUrl, oauthRequestUrl } from "@/config/config";
// banner 新增
export const bannerAdd = `${requestUrl}/manage/banner/add`;
// banner 编辑
export const banneEdit = `${requestUrl}/manage/banner/edit`;
// banner 列表
export const bannerList = `${requestUrl}/manage/banner/list`;
// banner 删除
export const bannerDelete = (id) => `${requestUrl}/manage/banner/delete?id=${id}`;
// banner 上移下移
export const bannerUpAndDown = `${requestUrl}/manage/banner/upAndDown`;






